'use client';
import { useStore } from '@/providers/app-store-provider';
import { ReportingCenter } from '@/reporting';
import { PepperjamProvider } from '@/reporting/providers/pepperjamProvider';
import { ProviderType } from '@/reporting/types';
import logger from '@/utils/client-logger';
import { useEffect } from 'react';

/**
 * Pepperjam 绑定初始化：落地 publisher / clickId / utm_campaign 落本地，登录后调 bind_pepperjam
 */
export const usePepperjamBindInit = () => {
  const token = useStore((state) => state.token);
  const refreshAccountInfo = useStore((state) => state.refreshAccountInfo);

  useEffect(() => {
    const handlePepperjamBinding = async () => {
      try {
        const center = ReportingCenter.getInstance();
        const pepperjamProvider = center.getProvider(ProviderType.PEPPERJAM) as PepperjamProvider;

        if (pepperjamProvider) {
          await pepperjamProvider.bindPepperjam(
            token,
            token
              ? () => {
                  refreshAccountInfo();
                }
              : undefined,
          );
        }
      } catch (error) {
        logger.error('Failed to handle pepperjam binding:', error);
      }
    };

    handlePepperjamBinding();
  }, [token, refreshAccountInfo]);
};
